import React, { useState, useEffect } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
import {
    FormInput,
    FormTemplate,
    FormTextArea,
    FormsSelect,
} from "../../../Components/Forms/InputTemplate";
import { FormProvider, useForm } from "react-hook-form";
import {
    ActionButtons,
    SupportButtons,
} from "../../../../global/components/Buttons/buttons";
import Table from "../../../Components/Table/Table";
import { useLocation, useNavigate } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { GetLocalStorage } from "../../../../../utils/functions/GetLocalStorage";
import { GetLoanSetup, CreateLoanRequisition, CreateEmployeeMedicalRequisition, CreatePaymentRequisition, GetAllPayroll, CreateExtendedHMOClaims, CreateCreditFacility, UpdateCreditFacility } from '../../../../../utils/redux/HR/HRSlice';
import { GetVendors } from "../../../../../utils/redux/Vendor/VendorSlice";
import {
    FormatDateTime,
    removeListData,
} from "../../../../../utils/functions/ResourceFunctions";
import FormUploadComponent from "../../../Components/Forms/FormUploadComponent";
import { TableActionsDownload } from "../../../Components/Misc/Actions";
import Select from 'react-select';
import { IoIosRemoveCircle } from "react-icons/io";
import AddFacilities from "../SetupAService/AddFacilitiesComponents";
import MultiSelect from "../../../Components/MultiSelect/MultiSelect";
import { useVendorGetQuery } from "../../../../api/vendorApi";
import { useNlpctGetQuery } from "../../../../api/nlpcApi";
import { useControlGetQuery } from "../../../../api/controlApi";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import { GetAllTransAccount, GetCreditFacility } from "../../../../../utils/redux/Finance/AccountingSetup/AccountingSetupSlice";
import { URL } from "../../../../../utils/routes";

function AddCreditFacility() {
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id');
    const [datas, setDatas] = useState('')
    const [isLoadings, setIsLoadings] = useState(true);
    const { allTransData } = useSelector(
        (state) => state?.accountLedgerSetup
    );
    useEffect(() => {
        dispatch(GetAllTransAccount({
            PageSize: 1000000,
            PageNumber: 1
        }))
        dispatch(GetCreditFacility(id)).then(res => {
            setDatas(res.payload?.result)
            setIsLoadings(false)
        });
    }, [id]);
    console.log('datas', datas)

    const { data: Vendor } = useVendorGetQuery(`/Vendor?PageSize=99999999&CurrentPage=1`);
    const { data: Bank } = useNlpctGetQuery(`/Util/GetAllBanks`);
    const dispatch = useDispatch();
    const [uploadFile, setUploadFile] = useState(null);
    const [vendorDocument, setVendorDocument] = useState([]);


    console.log('upload File', uploadFile);
    const [currentPage, setCurrentPage] = useState(1);
    const { all_payroll, isLoading } = useSelector((state) => state?.hr);
    const [searchQuery, setSearchQuery] = useState('');

    const [pageSize, setPageSize] = useState(10000);


    const vendor = useSelector((state) => state?.vendor);


    const [filter, setFilter] = useState('0');
    const [sort, setSort] = useState(0);



    const { data: DeclineSetup } = useControlGetQuery(`/DeclineSetup?ApprovalStatus=1&PageSize=999999`)
    console.log('decline setup', DeclineSetup);
    const navigate = useNavigate();

    const formMethods = useForm({
        mode: "all",
    });

    const {
        handleSubmit,
        reset,
        formState: { isValid },
    } = formMethods;




    const [componentList, setComponentList] = useState([

        {
            beneficiaryId: "",
            beneficiaryName: "",

        },
    ]);

    const handleAddComponent = () => {
        setComponentList((prevList) => [
            ...prevList,
            {
                beneficiaryId: 0,
                beneficiaryName: "",

            },
        ]);
    };

    const handleComponentChange = (index, e) => {
        const { name, value } = e.target;
        const updatedComponents = [...componentList];
        updatedComponents[index] = {
            ...updatedComponents[index],
            [name]: name === "beneficiaryId" ? parseInt(value, 10) : value,
        };
        setComponentList(updatedComponents);
    };

    const handleRemoveComponent = (index) => {
        const updatedComponents = [...componentList];
        updatedComponents.splice(index, 1);
        setComponentList(updatedComponents);
    };


    const submit = async (data, e) => {
        // Map vendorDocument to extract fileName and file separately
        console.log('vendorDocument', vendorDocument)
        const fileNames = vendorDocument.map(doc => doc.fileName);
        const files = vendorDocument.map(doc => doc.file?.name);

        // Create an array of objects for DocumentUri
        const documentUri = fileNames.map((fileName, index) => ({
            fileName,
            file: files[index],
            "documentType": fileName,
            "contentType": vendorDocument[index]?.file?.type
        }));

        function fileToBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result.split(',')[1]); // Extract Base64 string
                reader.onerror = error => reject(error);
            });
        }

        const documents = await Promise.all(
            vendorDocument.map(async (element, index) => {
                const base64File = await fileToBase64(element.file);
                return {
                    file: base64File,
                    fileName: element.file.name,
                    documentType: parseInt(element.fileName),
                    contentType: element.file.type,
                };
            })
        );

        const dataValues = {
            ...data,
            id: parseInt(id),
            "vendorId": JSON.parse(data?.venorId)?.id,
            "vendorName": JSON.parse(data?.venorId)?.businessName,
            "accountLedgerId": JSON.parse(data?.accountLedger)?.accountLedgerId,
            "accountLedgerName": JSON.parse(data?.accountLedger)?.accountLedgerName,
            "sourceId": JSON.parse(data?.source)?.bankId,
            "sourceName": JSON.parse(data?.source)?.bankName,
            "modeOfReceipt": parseInt(data?.modeOfReceipt),
            "purposeId": JSON.parse(data?.purpose)?.id,
            "purposeName": JSON.parse(data?.purpose)?.reason,
            documentUploads: documents

        }



        console.log("Submitted Data:", dataValues);

        //   // Log the file names separately
        // console.log("fileName:", vendorDocument.map(doc => doc.fileName).join(', '));

        // // Log the files separately
        // console.log("file:", vendorDocument.map(doc => doc.file?.name).join(', '));

        const fileData = new FormData();
        const key = Object.keys(dataValues);

        key?.forEach((key, index) => {
            fileData.append(`${key}`, dataValues[key]);
        });

        vendorDocument?.forEach((element, index) => {
            fileData.append(
                `Documents[${index}].file`,
                element?.file
            );
            fileData.append(`documentUploads[${index}].fileName`, element?.file?.name);
            fileData.append(`documentUploads[${index}].documentType`, element?.fileName);
            fileData.append(`documentUploads[${index}].contentType`, element?.file?.type);

        });

        if (id) {

            dispatch(UpdateCreditFacility(dataValues)).then((res) => {
                if (res?.payload?.successful === true) {
                    reset();
                    navigate(`${URL.Dashboard}/${URL.finance}/${URL.CreditFacility}`);
                    return;
                }
                toast.error(res?.payload?.statusMessage)
            });
            return;
        }

        dispatch(CreateCreditFacility(dataValues)).then((res) => {
            if (res?.payload?.successful === true) {
                reset();
                navigate(`${URL.Dashboard}/${URL.finance}/${URL.CreditFacility}`);
                return;
            }
            toast.error(res?.payload?.statusMessage)
        });
    };

    const documentList = [

        {
            name: "TinCertificate",
            value: 1,
        },

        {
            name: "CacCertificate",
            value: 2,
        },
        {
            name: "DriverLicense",
            value: 3,
        },
        {
            name: "InternationalPassport",
            value: 4,
        },


        {
            name: "SlaDocument",
            value: 5,
        }, {
            name: "PetrolReceipt",
            value: 6,
        }, {
            name: "DieselReceipt",
            value: 7,
        }, {
            name: "Receipt",
            value: 8,
        },


        {
            name: "Passport",
            value: 9,
        }, {
            name: "NOKPassport",
            value: 10,
        }, {
            name: "AcademicsCredentials",
            value: 11,
        }, {
            name: "LeaveDocument",
            value: 12,
        }, {
            name: "FuelRequisition",
            value: 13,
        }, {
            name: "MedicalDocuments",
            value: 14,
        }, {
            name: "SupportingDocument_1",
            value: 100,
        }, {
            name: "SupportingDocument_2",
            value: 101,
        }, {
            name: "NationalIDCard",
            value: 102,
        }, {
            name: "PermanentVoterCard",
            value: 103,
        },
        {
            name: "Facility",
            value: 104,
        },
    ];
    console.log('datas?.principal', datas?.principal)
    return (
        <PageLayout className={`!py-10 !overflow-y-auto !max-h-screen`} title={"Setup Credit Facility"} hasBack={true}>
            {!isLoadings &&
                <FormProvider  {...formMethods}>
                    <FormTemplate handleSubmit={handleSubmit(submit)} >
                        <section className={DashboardStyle.form_section}>
                            <h4 className={DashboardStyle.form_section_title}>Basic Information</h4>
                            <div className={DashboardStyle.inputs_group}>

                                <div>

                                    <FormInput type={'number'}
                                        title={"Principal"}
                                        camelCase={"principal"} defaultValue={datas?.principal}
                                        disabled={false}
                                        isOptional={false}
                                    />

                                    <FormInput
                                        title={"Interest Rate"} defaultValue={datas?.interestRate}
                                        camelCase={"interestRate"}
                                        disabled={false}
                                        isOptional={false}
                                    />
                                </div>


                                <div>
                                    <FormInput
                                        title={"Tenor"}
                                        camelCase={"tenor"} defaultValue={datas?.tenor}
                                        disabled={false} type={'number'}
                                        isOptional={false}
                                    />
                                    <FormsSelect
                                        title={"Vendor"} defaultId={JSON.stringify({ id: datas?.vendorId, businessName: datas?.vendorName })}
                                        camelCase={"venorId"} defaultValue={datas?.vendorName}
                                        placeholder={"Select Vendor"}

                                        array={Vendor?.result?.map(dat => <option key={dat?.id} value={JSON.stringify(dat)}>{dat?.businessName}</option>)}
                                    />

                                </div>
                                <div>

                                    <FormsSelect defaultId={JSON.stringify({ bankId: datas?.sourceId, bankName: datas?.sourceName })}
                                        title={"Source"}
                                        camelCase={"source"} defaultValue={datas?.sourceName}
                                        placeholder={"Select Source"}
                                        array={Bank?.responseObject?.map(bank => <option key={bank?.bankId} value={JSON.stringify(bank)}>
                                            {bank?.bankName}
                                        </option>)}
                                    />

                                    <FormsSelect
                                        title={"Mode Of Receipt"}
                                        camelCase={"modeOfReceip"} defaultId={datas?.modeOfReceipt === "Transfer" ? 0 : 1}
                                        defaultValue={datas?.modeOfReceipt}
                                        placeholder={"Select Mode of Receipt"}
                                        array={[{
                                            label: "Transfer", value: 0

                                        }, {
                                            label: "Cheque", value: 1

                                        }]?.map((dat, index) => <option key={index} value={dat?.value}>{dat?.label}</option>)}
                                    />

                                </div>
                                <div>
                                    <FormsSelect
                                        defaultValue={datas?.purposeName}
                                        defaultId={JSON.stringify({ id: datas?.purposeId, reason: datas?.purposeName })}
                                        title={"Purpose"}
                                        camelCase={"purpose"}
                                        placeholder={"Select Purpose"}
                                        array={
                                            DeclineSetup?.result?.items?.map(dat => <option key={dat?.id} value={JSON.stringify(dat)}>{dat?.reason}</option>)
                                        }
                                    />
                                    <FormsSelect
                                        title={"Account Ledger"}
                                        defaultId={JSON.stringify({ accountLedgerId: datas?.accountLedgerId, accountLedgerName: datas?.accountLedgerName })}
                                        camelCase={"accountLedger"} defaultValue={datas?.accountLedgerName}
                                        placeholder={"Select Account Ledger"}

                                        array={allTransData?.responseObject?.pageItems?.map(dat => <option key={dat?.id} value={JSON.stringify({
                                            accountLedgerName: dat?.vendorName, accountLedgerId: dat?.id
                                        })}>{dat?.vendorName}</option>)}
                                    />
                                </div>








                            </div>
                        </section>

                        <section className={DashboardStyle.form_section}>
                            <h4 className={DashboardStyle.form_section_title}>Uploads supporting document</h4>
                            <FormUploadComponent
                                documentList={documentList}
                                uploadFile={uploadFile}
                                setUploadFile={setUploadFile}
                                setVendorDocument={setVendorDocument}
                                vendorDocument={vendorDocument}
                                isOptional={false}
                            />
                        </section>

                        <section className={DashboardStyle.form_section}>
                            <h4 className={DashboardStyle.form_section_title}>Documents Uploads</h4>
                            <div className={`${DashboardStyle.labels_group} ${DashboardStyle.labels_group_downloads}`}>
                                {vendorDocument?.length === 0 ? (
                                    <p>No Record Available</p>
                                ) : (
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>File Name</th>
                                                <th>File Type</th>
                                                <th>Date Uploaded</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {vendorDocument?.map?.((x, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{x?.file?.name || x?.fileName}</td>
                                                        <td style={{ textTransform: "uppercase" }}>{x?.value || x?.fileName}</td>
                                                        <td>{FormatDateTime(new Date())}</td>
                                                        <td>
                                                            <TableActionsDownload
                                                                file={x?.file || null}
                                                                url={x?.fileUrl || null}
                                                                actions={() =>
                                                                    removeListData({
                                                                        value: index,
                                                                        list: vendorDocument,
                                                                        setList: setVendorDocument,
                                                                    })
                                                                }
                                                            />
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                )}
                            </div>
                        </section>




                        <div className={DashboardStyle.button_cage}>
                            <SupportButtons width={"auto"} onClick={() => navigate("../")}>
                                No,Cancel
                            </SupportButtons>
                            <ActionButtons disabled={!isValid} isLoading={isLoading} className={DashboardStyle?.button_cage_weight}>
                                {isLoading ? "Submitting" : "Submit"}
                            </ActionButtons>
                        </div>
                    </FormTemplate>
                </FormProvider>
            }
        </PageLayout>
    );
}

export default AddCreditFacility;
